module.exports = __webpack_public_path__ + "media/images/common/check_t-33b5b802659b85e4ef0f8de22940e80f.gif";